import Immutable from 'immutable';
import { handleActions } from 'redux-actions';
import { TYPES } from 'actions/appStateActions';
import { TYPES as ANNUAL_AVAILABILITY_TYPES } from 'actions/annualAvailabilityActions';
import { TYPES as BASE_STATE_TYPES } from 'actions/baseStateActions';
import { TYPES as APP_STATE_ACTION_TYPES } from 'actions/appStateActions';

const initialState = Immutable.fromJS({
  loadingState: 'loading',
  shouldSearchResultsTrackingEventsFire: true,
  pandaSearchFormActive: false,
  destinationQuery: '',
  hasNoDestinationResults: false,
  departureAirportQuery: '',
  reasonsToHideLandlinePhone: {
    bookPriceTooLow: true,
    disabledForLocation: true,
  },
  showPhoneNumber: false,
});

export default handleActions({
  [TYPES.ERROR_FIELD]: (state, action) => state.setIn(['errorFields', `${action.field}`], true),
  [TYPES.CLEAR_ERRORS]: state => state.set('errorFields', Immutable.Map()),
  [TYPES.LOADING_FINISH]: (state, action) => state.set(action.key, ''),
  [TYPES.LOADING_START_SPINNER]: (state, action) => state.set(action.key, 'spinning'),
  [TYPES.LOADING_START]: (state, action) => state.set(action.key, 'initiated'),
  [TYPES.UPDATE_SELECTED_OFFER_OF_DAY]: (state, action) => state.set('selectedOffer', action.offer),
  [TYPES.SET_PAGE_SCROLL_Y]: (state, action) => state.set('pageScrollY', action.pageScrollY),
  [TYPES.DELETE_PAGE_SCROLL_Y]: state => state.delete('pageScrollY'),
  [TYPES.SET_SEARCH_RESULTS_TRACKING_FLAG]: (state, action) => state.set('shouldSearchResultsTrackingEventsFire', action.flag),
  [TYPES.PANDA_SEARCH_FORM_TOGGLE]: (state, action) => state.set('pandaSearchFormActive', action.flag),
  [TYPES.SET_NON_DIMENSION_NUMBER_OF_NIGHTS]: (state, action) => state.set('nonDimensionNumberOfNights', action.numberOfNights),
  [TYPES.SET_VIEWPORT_DIMENSIONS]: (state, action) => state.set('viewportDimensions', Immutable.fromJS(action.viewportDimensions)).set('isMobileBreakpoint', action.isMobileBreakpoint),
  [TYPES.SET_DESTINATION_QUERY]: (state, action) => state.set('destinationQuery', action.destinationQuery),
  [TYPES.SET_HOTEL_QUERY]: (state, action) => state.set('hotelQuery', action.hotelQuery),
  [TYPES.SET_DEPARTURE_QUERY]: (state, action) => state.set('departureAirportQuery', action.departureAirportQuery),
  [TYPES.SET_HAS_NO_DESTINATION_RESULTS]: (state, action) => state.set('hasNoDestinationResults', action.hasNoDestinationResults),
  [TYPES.SET_HAS_NO_HOTEL_RESULTS]: (state, action) => state.set('hasNoHotelResults', action.hasNoHotelResults),
  [ANNUAL_AVAILABILITY_TYPES.CHANGE_NUMBER_OF_NIGHTS]: state => state.set('nonDimensionNumberOfNights', 0),
  [ANNUAL_AVAILABILITY_TYPES.SET_DIMENSION_PROPERTY]: state => state.set('nonDimensionNumberOfNights', 0),
  [BASE_STATE_TYPES.DELETE_BASESTATE_FIELD_KEY]: state => state.set('nonDimensionNumberOfNights', 0),
  [BASE_STATE_TYPES.CHANGE_BASESTATE_FIELD_KEY]: state => state.set('nonDimensionNumberOfNights', 0),
  [BASE_STATE_TYPES.BASE_STATE_SUCCESS]: state => state.set('nonDimensionNumberOfNights', 0),
  [TYPES.SHOW_HO_FLIGHT_UPSELL]: (state, action) => state.set('isHOFlightUpsellShown', action.show),
  [APP_STATE_ACTION_TYPES.SET_LHX_PROPERTY]: (state, action) => state.set(action.property, Immutable.fromJS(action.value)),
  [TYPES.LANDLINE_PHONE_SUCCESS]: (state, action) => state.set('landlinePhone', action.response.result.booking_number),
  [TYPES.HIDE_LANDLINE_PHONE]: (state, action) => {
    const isCurrentlyShown = state.get('showLandlinePhone');

    let newState = state.mergeIn(['reasonsToHideLandlinePhone'], Immutable.fromJS(action.reasons));
    const shouldNowBeShown = !newState.get('reasonsToHideLandlinePhone').some(reason => reason);

    return newState.set('showLandlinePhone', isCurrentlyShown || shouldNowBeShown);
  },
  [TYPES.SET_HAS_THIRD_PARTY_CHANNEL_PARAM_HO]: (state, action) => state.set('hasThirdPartyChannelParamHO', action.isThirdPartyChannelParam),
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/appStateReducer.js
 **/